import React, { useMemo } from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import Warning from '@material-ui/icons/Warning';
import { makeStyles, Theme } from '@material-ui/core/styles';
import SesamLink from 'Common/Links/SesamLink';
import Media from '../media';
import { AvatarConnectionString } from './AvatarConnectionString.view';
import { IdentityIcon } from '../identity-icon/IdentityIcon.view';

const useStyle = makeStyles((theme: Theme) => {
  return {
    datahubOutdatedIcon: {
      backgroundColor: 'transparent !important',
      color: theme.palette.error.main,
      cursor: 'pointer',
      marginTop: '2px',
    },
    headingSection: {
      margin: '0',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: theme.palette.text.primary,
      fontFamily: 'Barlow, sans-serif',
      fontSize: '1.25rem',
      fontWeight: 300,
    },
  };
});

export const SubscriptionAvatar: React.FC<{
  connectionUrl?: string;
  customConnectionURL?: string;
  name: string;
  nowrap?: boolean;
  subId: string;
  withLink?: boolean;
  isDefaultUrl?: boolean;
  shouldDisplayRestoreLinkButton?: boolean;
  datahubOutdated?: boolean;
  isConnected?: boolean;
  onRestoreConnectionClick: () => void;
  tooltipOnLClick?: () => void;
}> = ({
  connectionUrl,
  customConnectionURL,
  name,
  nowrap,
  subId,
  withLink,
  isDefaultUrl,
  shouldDisplayRestoreLinkButton,
  datahubOutdated,
  isConnected,
  onRestoreConnectionClick,
  tooltipOnLClick,
}) => {
  const classes = useStyle();

  const datahubOutdatedIcon = (
    <Tooltip title="The service instance is running a version that is too old. This voids the SLA. Please upgrade or contact support.">
      <Warning size="small" className={classes.datahubOutdatedIcon} onClick={tooltipOnLClick} />
    </Tooltip>
  );

  return (
    <Media
      img={datahubOutdated ? datahubOutdatedIcon : <IdentityIcon input={name} size={40} />}
      nowrap={nowrap}
      type="avatar"
    >
      <h3 className={classes.headingSection}>
        {withLink && (
          <SesamLink className="card--clickbox__target" title={name} to={`/subscription/${subId}`}>
            {name}
          </SesamLink>
        )}
        {!withLink && name}
      </h3>
      {isDefaultUrl || customConnectionURL || connectionUrl ? (
        <AvatarConnectionString
          customConnectionURL={customConnectionURL}
          connectionUrl={connectionUrl}
          isConnected={isConnected}
          onRestoreConnectionClick={onRestoreConnectionClick}
          shouldDisplayRestoreLinkButton={shouldDisplayRestoreLinkButton}
        />
      ) : (
        <i>
          <small title={'Connected to non-default url ' + connectionUrl}>{connectionUrl}</small>
        </i>
      )}
    </Media>
  );
};
